import { FlexRowCenter, Spacer } from "../atoms/Atoms"
import React from "react"
import { getFirstName } from "../../../reducers/userInfo"
import { useSelector } from "react-redux"
import { IlloUnderwaterChecklist } from "../atoms/Illustrations"
import L10n from "../../../lib/carrot-l10n"
import { BottomLinkMobileOnlyStyledWrapper } from "../atoms/Links"
import { SpacerSwitcher, SwitchH1ToH2 } from "./Molecules"
import { FleLayout } from "./FleLayout"
import { Body } from "../atoms/Bodies"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const FleDone = () => {
  const firstName = useSelector(getFirstName)
  return (
    <FleLayout>
      <FlexRowCenter>
        <IlloUnderwaterChecklist />
      </FlexRowCenter>
      <SpacerSwitcher />
      <SwitchH1ToH2>Thanks {firstName}.</SwitchH1ToH2>
      <SwitchH1ToH2>We’re excited to be a part of your journey.</SwitchH1ToH2>
      <Spacer height={0.5} />
      <Body>And remember, you can update your answers at any time.</Body>
      <Spacer height={3} />
      <FlexRowCenter>
        <BottomLinkMobileOnlyStyledWrapper>
          <ButtonPrimary to="/">{l`Go to Carrot home`}</ButtonPrimary>
        </BottomLinkMobileOnlyStyledWrapper>
      </FlexRowCenter>
    </FleLayout>
  )
}

export default FleDone
